import { CardLoader, ListPagination } from 'components/organisms'
import { FINANCE_PAYMENTS_COLUMNS } from './finance-payments-url-params-table-columns'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import FinancePaymentsUrlParamsTableRow from './finance-payments-url-params-table-row'

const propTypes = {
  tableProps    : PropTypes.object,
  payments  : PropTypes.array,
  pagination    : PropTypes.object,
  onPageChange  : PropTypes.func,
  isLoading     : PropTypes.bool,
  onClickRow    : PropTypes.func,
  onSelectRow   : PropTypes.func,
  hiddenColumns : PropTypes.array
}

const defaultProps = {
  isLoading     : true,
  onPageChange  : () => { },
  hiddenColumns : []
}

/**
 * Table to display specific Payments data
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} payments - array of Payments
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - boolean for withLoader animation
 * @param {Function} onPageChange - function that will handle page change
 * @param {Function} onClickRow - function to navigate to payment detail page when admin click on data row
 * @param {Array<String>} hiddenColumns - Array of hidden columns name
 */
const FinancePaymentsUrlParamsTable = ({
  tableProps,
  payments,
  pagination,
  isLoading,
  onPageChange,
  onClickRow,
  hiddenColumns
}) => {
  const financePaymentsColumns      = FINANCE_PAYMENTS_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))
  const financePaymentsHeaderLength = financePaymentsColumns.length
  const totalColumns                  = financePaymentsHeaderLength
  const isPaymentsNotFound        = (payments?.length ?? 0) === 0

  const TableContent = () => (
    <>
      <Table { ...tableProps }>
        <thead>
          <tr>
            {
              financePaymentsColumns.map((column) => (
                <th key={ `finance-payments-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            payments?.map((payment) => (
              <FinancePaymentsUrlParamsTableRow
                key={ `finance-payments-data-${payment.id}` }
                payment={ payment }
                onClickRow={ onClickRow }
                hiddenColumns={ hiddenColumns }
                financePaymentsColumns={ financePaymentsColumns }
              />
            ))
          }
          {
            isPaymentsNotFound && (
              <tr>
                <td
                  colSpan={ totalColumns }
                  className='bg-warning text-white'
                >
                  <i className='fas fa-info-circle mr-3' />
                  { 'Finance Payments tidak ditemukan.' }
                </td>
              </tr>
            )
          }
        </tbody>
      </Table>
    </>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}

FinancePaymentsUrlParamsTable.propTypes    = propTypes
FinancePaymentsUrlParamsTable.defaultProps = defaultProps

export default FinancePaymentsUrlParamsTable